'use strict';

wbApp.factory('courseTypeSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {

        var CourseTypes = $resource('/Api/CourseTypes/:id', {}, {
            'getLookup': { method: 'GET', isArray: true, url: '/Api/CourseTypes/GetLookup' },
            'getAll': { method: 'GET', isArray: true, url: '/Api/CourseTypes/GetAll' },
            'update': { method: 'POST', url: '/Api/CourseTypes/Update' },
            'insert': { method: 'POST', url: '/Api/CourseTypes/Insert' },
            'delete': { method: 'POST', url: '/Api/CourseTypes/Delete' }
        });

        var courseTypes, courseTypesBriefs;

        function createNew() {
            return {};
        }

        function getAllAsync(reload) {
            if (!courseTypes || reload) {
                courseTypes = repositorySvc.customGet('getAll', CourseTypes);
            }

            return courseTypes;
        }

        function getAllForLookup(reload) {
            if (!courseTypesBriefs || reload) {
                courseTypesBriefs = repositorySvc.customGet('getLookup', CourseTypes);
            }

            return courseTypesBriefs;
        }

        function getByIdAsync(id) {
            return $q(function (resolve, reject) {
                getAllAsync().$promise.then(function (res) {
                    resolve(_.find(res, { courseTypeID: id }));
                }, reject)
            });
        }

        function insert(data, successCallback, errorCallback) {
            repositorySvc.insert(
                CourseTypes,               // $resource
                courseTypes,               // collection
                data,                      // entity
                function (data) {
                    if (successCallback) {
                        successCallback(data);
                    }

                    courseTypesBriefs = null;
                },
                errorCallback,
                'courseTypeID');
        }

        function update(data, successCallback, errorCallback) {
            repositorySvc.update(
                CourseTypes,            // $resource
                courseTypes,            // collection
                data,                   // entity
                function (data) {
                    if (successCallback) {
                        successCallback(data);
                    }

                    courseTypesBriefs = null;
                },
                errorCallback,
                'courseTypeID');
        }

        function remove(data, successCallback, errorCallback) {
            repositorySvc.remove(
                CourseTypes,              // $resource
                courseTypes,              // collection
                data,                     // entity
                function (data) {
                    if (successCallback) {
                        successCallback(data);
                    }

                    courseTypesBriefs = null;
                },
                errorCallback,
                { courseTypeID: data.courseTypeID },
                'courseTypeID');
        }

        return {
            createNew: createNew,
            getAllAsync: getAllAsync,
            getAllForLookup: getAllForLookup,
            getByIdAsync: getByIdAsync,
            insert: insert,
            update: update,
            remove: remove
        }
    }]);